<template>
  <div class="copyrightNotice">
    <h6>2010-2025© Eats on Feets™</h6>
      <p>
        Copyright Notice: We support 'Fair Use' of these pages for Academic &amp; Non Commercial use.
        Reproductions in whole or part are approved but any modifications need additional permission.
        Any and all reproductions must contain author credit, not be sold, and presented with Copyright.
      </p>
  </div>
</template>

<script>
export default {
  name: 'CopyrightNotice'
}
</script>
<style lang="scss" scoped>
.copyrightNotice {
  width: 45%;
  h5 {
    font-size: 1.1em
  }
}

h3 {
  font-weight: bold;
}

p {
  font-size: .8em;
}
@media screen and (max-width: 415px) {
  .copyrightNotice {
    width: 100%;
    margin-right: 20px;
  }
}
</style>
